<template>
  <div>
    <el-dialog
      v-if="visible"
      v-el-dialog-drag
      show-close
      :visible="visible"
      append-to-body
      width="1200px"
      top="5vh"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => (backDialogVisible = true)"
    >
      <Main
        ref="main"
        :data="data"
        :errorKeys="errorKeys"
        @close="close"
        @reload="$emit('reload')"
        @delete="onMainDelete"
      />
      <span slot="footer">
        <el-button size="small" @click="() => (backDialogVisible = true)">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      backDialogVisible: false,
      errorKeys: [],
    }
  },
  methods: {
    async save() {
      const formData = await this.$refs.main.getData()
      if (!formData) return (this.backDialogVisible = false)
      if (!this.data || !this.data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }
      const { expenseCustCode } = formData
      this.errorKeys = this.data
        .filter(
          (i) => i.expenseCustCode != expenseCustCode || !i.expenseCustName
        )
        .map((i) => i.shipmentPayStatementCode)

      if (this.errorKeys && this.errorKeys.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('tips_expense_customer_is_consistent_cannot_bank') ||
            '费用客户一致且不能为空',
          type: 'error',
        })
        return
      }

      // 判断是否都是相同类型的
      const { payTo: firstPayTo } = this.data[0]
      const payToEvery = this.data.every((item) => item.payTo == firstPayTo)

      if (payToEvery) {
        this.submitReview(this.data)
        return
      }
      const h = this.$createElement
      const confirm = await this.$confirm(
        h('div', null, [
          h(
            'p',
            null,
            this.$l('tips_confirm_submitReview') ||
              '您所选的结算单存在不同结算方类型，是否确认提交审核？'
          ),
          h('p', null, [
            h('p', null, [
              h(
                'i',
                { style: 'color: teal' },
                this.$l('tips_confirm_submitReview_freight') || '货代：'
              ),
              h(
                'span',
                null,
                this.$l('tips_confirm_submitReview_freight_context') ||
                  '将合并为一个费用填报单并提交OA请款 '
              ),
            ]),
            h('p', null, [
              h(
                'i',
                { style: 'color: teal' },
                this.$l('tips_confirm_submitReview_transport') || '运输公司：'
              ),
              h(
                'span',
                null,
                this.$l('tips_confirm_submitReview_transport_context') ||
                  '将修改为提交审核状态 '
              ),
            ]),
          ]),
        ]),
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText:
            this.$l('tips_confirm_submitReview_confirmButtonText') || '提交',
          cancelButtonText:
            this.$l('tips_confirm_submitReview_cancelButtonText') || '取消提交',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.submitReviewApi(this.data)
    },
    submitReview(listData) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.submitReviewApi(listData)
      })
    },
    async submitReviewApi(listData) {
      const linkUrl = this.$joinURL(`/opview/shipment/expense`, {
        joinOrigin: true,
        joinBasePath: false,
      })
      this.loadingOpen()
      const listCode = listData.map((item) => item.shipmentPayStatementCode)
      const res = await this.$api
        .shipmentPayStatementSubmitReviewApi({ listCode, linkUrl })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.tips_submission_failed') || '提交失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.onMainDelete(listData)
      this.close()
      this.$emit('reload')
    },
    onMainDelete(e) {
      this.$emit('delete', e)
    },
    close() {
      this.errorKeys = []
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
